// Shared Recharts styling, defined once so charts don't get new prop objects on every render.
export const AXIS_TICK = { fill: "#71717A", fontSize: 11 };
export const TOOLTIP_STYLE = { background: "#16141D", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8 };
export const CURSOR = { fill: "rgba(255,255,255,0.03)" };
export const BAR_RADIUS = [3, 3, 0, 0];
export const INITIAL_DIM = { width: 320, height: 192 };
